import BASEURLPROJETOS from '../api/projetos'
import { BuscarIndicadoresQuery, IndicadorPayload, AtualizarIndicadorPayload } from "../../interfaces/indicadores"

export function listarBancoIndicador(queryParams: BuscarIndicadoresQuery) {
  return BASEURLPROJETOS.get(`/indicadores?titulo=${queryParams.titulo}&situacao=${queryParams.situacao}&grupo=${queryParams.grupo}`);
}

export function listarIndicadores(queryParams: BuscarIndicadoresQuery) {
  return BASEURLPROJETOS.get(`/indicadorProjeto?titulo=${queryParams.titulo}&situacao=${queryParams.situacao}&idProjeto=${queryParams.idProjeto}&grupo=${queryParams.grupo}`);
}

export function cadastrarIndicadorAoProjeto(payload: IndicadorPayload) {
  return BASEURLPROJETOS.post(`/indicadorProjeto`, payload);
}

export function atualizarIndicadorProjeto(idIndicadorProjeto: string, payload: AtualizarIndicadorPayload) {
  return BASEURLPROJETOS.patch(`/indicadorProjeto/${idIndicadorProjeto}`, payload);
}

export function atualizarMensuracao(idIndicadorMensuracao: string, payload: AtualizarIndicadorPayload) {
  return BASEURLPROJETOS.patch(`/mensuracao/:${idIndicadorMensuracao}`, payload);
}
